module.exports = __webpack_public_path__ + "static/media/25488352_1703509169724267_4583340573761654026_o.120c11da.jpg";